<template>
  <div class="page question-basket">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/pt/exercise-center' }"
        >练习中心</el-breadcrumb-item
      >
      <el-breadcrumb-item @click.native="goBack" class="pointer">{{
        fromType === "mt" ? "同步练习" : "共性分析"
      }}</el-breadcrumb-item>
      <el-breadcrumb-item>题目预览</el-breadcrumb-item>
    </el-breadcrumb>
    <card-header class="mt-20 mb-30">查看试题篮</card-header>
    <div class="hr"></div>
    <div class="question-basket__body">
      <!-- 题目详情 -->
      <section class="body-left">
        <basket-header
          >{{ this.time }}{{ this.categoryObj.subjectName }}
          {{ fromType === "mt" ? "同步练习" : "高频错题练习" }}</basket-header
        >
        <question-content
          :questionList="this.questionsBasket"
          fromPage="FromBasket"
        />
      </section>
      <!-- 发布练习 -->
      <section class="body-sidebar" ref="bodySidebar">
        <div ref="sidebar" :class="isFixed == true ? 'isFixed' : ''">
          <div class="sidebar-button">
            <button class="arrange pointer" @click="publishMt">
              {{ fromType === "mt" ? "布置同步练习" : "布置练习" }}
            </button>
            <!-- <button class="pointer">下载练习</button> -->
            <button
              class="pointer"
              @click="goExport"
            >
              <span class="point">打印练习</span>
            </button>
          </div>
          <ul class="sidebar-content">
            <li class="knowledge-count">
              <span class="dot-span">已选择知识点：</span>
              <span>{{ knowledgeCount.size }}个</span>
            </li>
            <li class="topic-count">
              <p class="question-count">
                <span class="dot-span">已选择题目：</span>
                <span>{{ totalCount }}道</span>
              </p>
              <div
                v-for="(countNum, name) in count"
                :key="name"
                class="question-type"
              >
                <p v-if="name === '其他'">
                  <span>{{ name }}</span>
                  <span>{{ countNum }}篇{{ childCount }}道</span>
                </p>
                <p v-else>
                  <span>{{ name }}</span>
                  <span>{{ countNum }}道</span>
                </p>
              </div>
            </li>
            <li class="go-back pointer" @click="goBack">继续添加题目</li>
            <li class="tips">
              tips: 为保障练习效果，一次最多选择<span>50</span>道题目
            </li>
          </ul>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import CardHeader from '@/components/card-header.vue';
import BasketHeader from '@/components/basket-header.vue';
import QuestionContent from './components/question-content.vue';

export default {
  name: 'QuestionBasket',
  components: {
    CardHeader,
    BasketHeader,
    QuestionContent,
  },
  data() {
    const { fromType } = this.$route.query;
    return {
      time: '',
      fromType,
      isFixed: false,
    };
  },
  computed: {
    ...mapGetters([
      'questionsBasket',
      'knowledgeName',
      'singleChoiceCount',
      'multipleChoiceCount',
      'completionCount',
      'decideCount',
      'categoryObj',
      'gapFillingCount',
      'setMembershipCount',
    ]),
    knowledgeCount() {
      const count = new Set();
      this.knowledgeName.forEach((x) => count.add(x));
      return count;
    },
    count() {
      return {
        单选题: this.singleChoiceCount,
        多选题: this.multipleChoiceCount,
        填空题: this.completionCount,
        判断题: this.decideCount,
        选词填空: this.gapFillingCount,
        其他: this.setMembershipCount,
      };
    },
    totalCount() {
      let count = 0;
      this.questionsBasket.forEach((item) => {
        if (item.child_question_num > 0) {
          count += item.child_question_num;
        } else {
          count += 1;
        }
      });
      return count;
    },
    childCount() {
      let count = 0;
      this.questionsBasket.forEach((item) => {
        if (item.question_title_uuid !== '') {
          count += Number(item.child_question_num);
        }
      });
      return count;
    },
  },
  methods: {
    handleScroll() {
      const headerTop = this.$refs.sidebar && this.$refs.sidebar.getBoundingClientRect().top;
      const contentTop = this.$refs.bodySidebar.getBoundingClientRect().top;
      this.$nextTick(() => {
        if (contentTop > 0) {
          this.isFixed = false;
        }
        if (headerTop < 0) {
          this.isFixed = true;
        }
      });
    },
    publishMt() {
      if (this.questionsBasket.length > 0) {
        this.$router.push({
          path: '/pt/publish-mt',
          query: {
            from: this.fromType,
          },
        });
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    goExport() {
      console.log('我要去打印-----------------');
      this.$router.push({
        path: '/pt/export-question',
      });
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'CreateMt') {
      this.$set(to.meta, 'isUseCache', true);
    }
    if (to.name === 'ExerciseAnalyze' || to.name === 'ExerciseTypeAnalyze') {
      this.$set(to.meta, 'isUseCache', true);
    }
    next();
  },
  mounted() {
    const myDate = new Date();
    let tMonth = myDate.getMonth() + 1;
    let tDay = myDate.getDate();
    tMonth = tMonth < 10 ? `0${tMonth}` : tMonth;
    tDay = tDay < 10 ? `0${tDay}` : tDay;
    this.time = `${tMonth}${tDay}`;
    window.addEventListener('scroll', this.handleScroll, true);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll, true);
  },
};
</script>
<style lang="scss" scoped>
.question-basket {
  &__body {
    display: flex;
    .body-left {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-right: 27px;
    }
    .body-sidebar {
      background: #f3f6fd;
      width: 240px;
      padding-left: 10px;
      .isFixed {
        background: #ffffff;
        position: fixed;
        top: 0;
      }
      .sidebar-button {
        width: 240px;
        background: #ffffff;
        display: flex;
        flex-direction: column;
        align-items: center;
        button {
          width: 200px;
          height: 40px;
          border-radius: 4px;
          border: 1px solid #1989fa;
          font-size: 15px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #1989fa;
          margin-top: 16px;
        }
        .arrange {
          background: #1989fa;
          color: #ffffff;
        }
        .point {
          background: url("../images/print.png") no-repeat left center;
          background-size: 18px 18px;
          padding-left: 24px;
        }
      }
      .sidebar-content {
        width: 240px;
        background: #ffffff;
        padding-top: 24px;
        li {
          width: 200px;
          min-height: 48px;
          border-radius: 4px;
          margin: 0 auto;
          box-sizing: border-box;
          font-size: 15px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #000000;
        }
        .dot-span {
          position: relative;
          white-space: nowrap;
          padding-left: 13px;
          &::before {
            content: "";
            position: absolute;
            left: 0;
            top: 50%;
            transform: translate(0, -50%);
            width: 4px;
            height: 4px;
            background: #000000;
            border-radius: 4px;
          }
        }
        .knowledge-count {
          line-height: 48px;
          padding: 0 13px;
          display: flex;
          justify-content: space-between;
          background: #f2f2f2;
        }
        .topic-count {
          margin-top: 8px;
          padding: 0 13px 13px;
          background: #f2f2f2;
          .question-count {
            padding: 14px 0;
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid #dce1eb;
          }
          .question-type {
            display: flex;
            justify-content: space-between;
            font-size: 15px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #5a5e66;
            padding-left: 14px;
            margin-top: 14px;
          }
        }
        .go-back {
          font-size: 15px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #1989fa;
          line-height: 48px;
          text-align: right;
          background: url("../images/add.png") no-repeat center;
          background-size: 14px 14px;
        }
        .tips {
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(17, 31, 44, 0.6);
          background: url("../images/tips.png") no-repeat;
          background-size: 12px 18px;
          text-indent: 22px;
          span {
            color: #ffd501;
          }
        }
      }
    }
  }
}
</style>
